import {
  ChangeDetectionStrategy,
  Component,
  effect,
  Inject,
  Injector,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AuthModule, AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { assertTruthy } from '@thred/shared-common';

@Component({
  selector: 'thred-landing',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatButtonModule,
    RouterModule,
    AuthModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AuthModule],
})
export class LandingComponent implements OnInit {
  isLoading = toSignal(this.authService.isLoading$);
  isAuthenticated = toSignal(this.authService.isAuthenticated$);
  @Input({ required: true }) logoPath = '';
  @Input({ required: true }) defaultRedirectUrl = '';
  @Input() signUpOption = false;
  @Input() signUpUrl = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private injector: Injector,
    @Optional() @Inject('LOGO_PATH') private providedLogoPath?: string,
    @Optional()
    @Inject('DEFAULT_REDIRECT_URL')
    private providedDefaultRedirectUrl?: string,
  ) {}

  ngOnInit() {
    this.logoPath = this.logoPath || this.providedLogoPath || '';
    this.defaultRedirectUrl =
      this.defaultRedirectUrl || this.providedDefaultRedirectUrl || '';

    effect(
      async () => {
        if (this.isAuthenticated()) {
          const redirectUrl =
            this.activatedRoute.snapshot.queryParams['redirect'];
          if (typeof redirectUrl == 'string' && redirectUrl !== '') {
            await this.router.navigateByUrl(redirectUrl);
          } else {
            assertTruthy(this.defaultRedirectUrl);
            await this.router.navigateByUrl(this.defaultRedirectUrl);
          }
        }
      },
      { injector: this.injector },
    );
  }

  login() {
    this.authService.loginWithPopup();
  }
}
